import { computed, onBeforeMount, ref, watch } from 'vue'
import { useStore } from 'vuex'

export default function useActiveDeliveryType({
  activeDeliveryType,
  typesFilter,
  deliveryTypes,
  showServicesList,
  resetService,
}) {
  const store = useStore()

  const currentDeliveryType = ref({})
  const pickpointsLoading = ref(true)

  const isDeliveryLoadingWhenProfileSelected = computed(
    () => store.state.isDeliveryLoadingWhenProfileSelected
  )
  const userEditProfile = computed(
    () => store.state.checkoutScenario === 'userEditProfile'
  )
  const getCountry = computed(() => store.state.country)

  watch(activeDeliveryType, (newVal, oldVal) => {
    currentDeliveryType.value = activeDeliveryType.value

    // ищем полный объект типа в общем списке
    const typeFromList = deliveryTypes.value.find(
      (e) => e.ID === currentDeliveryType.value?.ID
    )

    // если он ещё не пришёл — берём пустой массив, чтобы не было «Cannot read … 'ITEMS'»
    currentDeliveryType.value.ITEMS = typeFromList?.ITEMS ?? []
    if (
      userEditProfile.value ||
      isDeliveryLoadingWhenProfileSelected.value ||
      newVal.ID === oldVal.ID
    )
      return

    // костыль для случаев, когда сначала выбрана курьерка в Москве, а потом самовывоз в Москве (typesFilter в UnAuth не отрабатывает, приходится тригерить лишний раз здесь)
    showServicesList(currentDeliveryType.value.ITEMS, currentDeliveryType.value)
  })

  watch(typesFilter, () => {
    if (!isDeliveryLoadingWhenProfileSelected.value) {
      showServicesList(
        currentDeliveryType.value.ITEMS,
        currentDeliveryType.value
      )
    }
  })

  watch(deliveryTypes, (nv, ov) => {
    if (nv === ov) return

    const isActiveTypeEmpty = !Object.keys(activeDeliveryType.value ?? {})
      .length
    if (isActiveTypeEmpty) {
      currentDeliveryType.value = undefined
    }
  })

  watch(currentDeliveryType, (nv) => {
    if (nv) resetService() // очищаем локально при изменении типа доставки
  })

  onBeforeMount(() => {
    // кейс Украины
    if (deliveryTypes.value?.length) {
      currentDeliveryType.value =
        getCountry.value.code === 'UA'
          ? deliveryTypes.value[1]
          : deliveryTypes.value[0]
    }

    const hasActiveType = Object.keys(activeDeliveryType.value ?? {}).length > 0
    if (hasActiveType) {
      currentDeliveryType.value = deliveryTypes.value.find(
        (el) => activeDeliveryType.value.ID === el.ID
      )
    }

    const hasItems = currentDeliveryType.value?.ITEMS?.length > 0
    const isCourier = currentDeliveryType.value?.ID === 'COURIER'

    if (hasItems) {
      showServicesList(
        currentDeliveryType.value.ITEMS,
        currentDeliveryType.value
      )
    }

    if (isCourier) {
      showServicesList(
        deliveryTypes.value.find((tp) => tp.ID === currentDeliveryType.value.ID)
          .ITEMS,
        currentDeliveryType.value
      )
    }
    pickpointsLoading.value = false
  })

  return {
    currentDeliveryType,
    pickpointsLoading,
  }
}
